/* Gallery 2026 — arrow controls scroll the photo track. Dependency-free. */
(function () {
    function initGallery(gallery) {
        var track = gallery.querySelector('.gallery2026__track');
        if (!track) {
            return;
        }
        var prev = gallery.querySelector('.gallery2026__arrow--prev');
        var next = gallery.querySelector('.gallery2026__arrow--next');

        function step() {
            var slide = track.querySelector('.gallery2026__slide');
            var gap = 16; // matches .gallery2026__track gap
            return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        }

        if (prev) {
            prev.addEventListener('click', function () {
                track.scrollBy({ left: -step(), behavior: 'smooth' });
            });
        }
        if (next) {
            next.addEventListener('click', function () {
                track.scrollBy({ left: step(), behavior: 'smooth' });
            });
        }
    }

    function init() {
        document.querySelectorAll('[data-gallery2026]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
